<template lang="pug">
  #popup-recruitment.popup__main(:class="{'style-tech': position === 'tech'}")
    .popup__header
      a(href="#" @click.prevent="closePopup").popup__close
    .popup__content
      .popup__title
        p {{ positionInfo[position].title }}
      ul.popup_list
        li(v-for="item in positionInfo[position].list")
          p.popup_list-title {{ item.title }}
          p.popup_list-content(v-html="item.content")
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'PopupRecruitment',
  props: {
    position: String,
  },
  data: () => {
    return {
      positionInfo: {
        sales: {
          title: '[業務菁英人才]',
          list: [
            {
              title: 'PropTech 房產科技助成交，精準銷售不白忙',
              content: '業務最怕抓不準客戶需求，總是瞎忙 ! 信義房屋透過「AI 智能配案」，用大數據演算，幫你配對適合客戶的理想物件，提升配案精準率、成交速度UP。總公司更有超過百位數位科技人才，持續研發、持續創新，當你最強大的後盾。',
            },
            {
              title: '保障月薪 5 萬六個月，30 天工作鑑賞期轉職金 5 萬',
              content: '提供前六個月保障月薪 $50,000 元，讓新人能安心練功，累積不動產專業。想從事業務工作，卻不知道合不合適？ 業界首創 30 天工作鑑賞期，讓你來試用公司。期滿覺得不適合，公司再加發 $50,000 轉職金 !',
            },
            {
              title: '新人 180 天全方位培育計畫，百堂訓練課程及 1 對 1 師徒制',
              content: '集團有專任講師團隊研發課程、定期新人關懷並提供諮詢輔導。並針對不同職級設計遊戲化學習地圖，提供超業心法、銷售技巧、產業趨勢、podcast 頻道等多元線上影音資源。工作日常更有專屬師父手把手帶你，做中學，讓「業務新手」快速變成「房仲高手」。',
            },
          ]
        },
        tech: {
          title: '[數位科技人才]',
          list: [
            {
              title: '打造 PropTech 自家產品高潛力的房產科技發展空間',
              content: 'PropTech 相較 FinTech、MarTech 在台灣討論度還不高，但卻是一個在高度發展的科技領域。我們已陸續推出「DiNDON 智能賞屋」<span>、</span>「AI 智能配案」、專為業務量身打造的「Super Agent」等自家產品。歡迎加入我們，一起動手創新、放手造局 !',
            },
            {
              title: '多元職涯發展、海內外集團輪調機會',
              content: '內部推動系統化能力發展地圖及個人發展計畫。你可以透過參與各產品專案，加速技能提升，並在工作歷練中持續提升技術力與軟實力。集團海內外跨產業多元佈局，更有多元輪調機會，提供實戰舞台讓你發光。',
            },
            {
              title: '內部定期技術分享、職能工作坊，持續交流最新科技',
              content: '團隊定期舉辦技術交流會、工作坊，鼓勵參與各類研討會及論壇，更有外訓費用補助、內訓計畫及企業包班，也提供多元外部學習資源(如: Hahow)自由運用，持續創新 PropTech 領域，走在趨勢最前端。',
            },
          ]
        }
      }
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations(['closePopup']),
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style lang="scss">

#popup-recruitment {

  color: #fff;
  background: rgba(#388246, .95);

  width: vwXL(1440);
  border: rgba(#fcfefd, .95) vwXL(12) solid;

  @include tablet {
    width: vw(666);
    border: rgba(#fcfefd, .95) vw(10) solid;
  }

  &.style-tech {
    background: rgba(#046b71, .95);
  }

  .popup__header {

    display: flex;
    justify-content: space-between;
    height: vwXL(143);
    margin-bottom: vwXL(50);
    
    @include tablet {
      // display: flex;
      // justify-content: space-between;
      height: vw(74);
      margin-bottom: vw(30);
    }

  }

  .popup__close {
    margin-left: auto;

    width: vwXL(135);
    background: url('~@/assets/images/common/popup-close_desktop.png') center center no-repeat;
    background-size: vwXL(73) vwXL(73);

    @include tablet {
      width: vw(72);
      background: url('~@/assets/images/common/popup-close.png') center center no-repeat;
      background-size: vw(40) vw(40);
    }
  }

  .popup__content {

    padding: 0 0 vwXL(112) vwXL(136);

    @include tablet {
      padding: 0 0 vw(31) vw(44);
    }

  }

  .popup__title {
    padding-bottom: vwXL(60);
    @include tablet {
      padding-bottom: vw(33);
    }
    p {
      font-size: vwXL(67);
      letter-spacing: vwXL(PsdLetterSpacing(100, 67));
      text-indent: vwXL(-6);
      transform: scaleX(0.97);
      transform-origin: left top;
      @include tablet {
        font-size: vw(37.4);
        letter-spacing: vw(PsdLetterSpacing(100, 37.4));
        text-indent: vw(-4);
        // transform: scaleX(0.97);
        // transform-origin: left top;
      }
    }
  }

  .popup_list {
    overflow: hidden;
    li {
      position: relative;
      padding-bottom: vwXL(60);
      padding-left: vwXL(56);
      @include tablet {
        padding-bottom: vw(37);
        padding-left: vw(30);
      }
      &:before {
        content: '';
        position: absolute;
        top: vwXL(24);
        left: 0;
        width: vwXL(18);
        height: vwXL(18);
        background: #fff;
        @include tablet {
          top: vw(17);
          // left: 0;
          width: vw(10);
          height: vw(10);
          // background: #fff;
        }
      }
    }
  }

  .popup_list-title {
    width: 94.9%;
    font-size: vwXL(58);
    font-weight: 400;
    text-align: justify;
    letter-spacing: vwXL(PsdLetterSpacing(20, 58));
    line-height: lineHeight(58, 78);
    margin-bottom: vwXL(18);
    transform: scaleX(0.95);
    transform-origin: left top;
    @include tablet {
      // width: 94.9%;
      font-size: vw(32);
      // font-weight: 400;
      // text-align: justify;
      letter-spacing: vw(PsdLetterSpacing(20, 32));
      // line-height: lineHeight(32, 43);
      margin-bottom: vw(7);
      // transform: scaleX(0.95);
      // transform-origin: left top;
    }
  }

  .popup_list-content {
    width: 98%;
    color: #b7eac3;
    font-size: vwXL(43);
    font-weight: 400;
    text-align: justify;
    letter-spacing: vwXL(PsdLetterSpacing(20, 43));
    line-height: lineHeight(43, 65);
    transform: scaleX(0.92);
    transform-origin: left top;
    @include tablet {
      // width: 98%;
      // color: #b7eac3;
      font-size: vw(24);
      // font-weight: 400;
      // text-align: justify;
      letter-spacing: vw(PsdLetterSpacing(30, 24));
      // line-height: lineHeight(24, 36);
      // transform: scaleX(0.92);
      // transform-origin: left top;
    }
    span {
      margin: 0 vwXL(-20);
      @include tablet {
        margin: 0 vw(-15);
      }
    }
  }

  &.style-tech .popup_list-content {
    color: #b7d6ea;
  }

}

</style>
